import React from "react";
import CourieButton from "@src/common/components/Button/Button";
import { Tooltip } from "@src/common/components";
import { Kbd } from "@src/common/components/Kbd/Kbd";
import { useShipmentFiltersContext } from "../context/ShipmentFiltersContext";
import { ShipmentsPrimaryFilterType } from "../types";
import CheckedShipmentsStatus from "./CheckedShipmentsStatus";
import { useBulkShipmentActions } from "../hooks/useBulkShipmentActions";

interface CheckedShipmentsActionsProps {
  showSelectAllButton: boolean;
}

const CheckedShipmentsActions: React.FC<CheckedShipmentsActionsProps> = ({
  showSelectAllButton,
}) => {
  const { selectedPrimaryFilter } = useShipmentFiltersContext();
  const { actions } = useBulkShipmentActions();

  return (
    <>
      {selectedPrimaryFilter === ShipmentsPrimaryFilterType.UNASSIGNED && (
        <CheckedShipmentsStatus showSelectAllButton={showSelectAllButton} />
      )}
      {actions
        .filter((action) => action.show)
        .map((action) => (
          <React.Fragment key={action.key}>
            <Tooltip
              content={
                action.disabledReason || (
                  <span className="flex items-center gap-1.5">
                    {action.label}
                    {action.shortcut && (
                      <Kbd>{action.shortcut.toUpperCase()}</Kbd>
                    )}
                  </span>
                )
              }
              placement={"bottom"}
              className="z-50"
            >
              <CourieButton
                size="xs"
                color={action.color}
                onClick={action.onClick}
                disabled={action.disabled}
                isProcessing={action.isProcessing}
              >
                {action.icon}
                {action.showLabelOnButton && (
                  <span className="ml-1">{action.label}</span>
                )}
              </CourieButton>
            </Tooltip>
          </React.Fragment>
        ))}
    </>
  );
};

export default CheckedShipmentsActions;
